const InfoLabel = ({ label, value, className = "" }) => (
  <>
    <div className={`infoTitle ${className}`.trim()}>{label}</div>
    {!!value && <div className={`infoValue ${className}`.trim()}>{value}</div>}
  </>
);

export default InfoLabel;
